var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversationPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 9,
    viewBox: "0 0 24 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 156.032c-1.6 0-3.15.254-4.6.731v3.149c0 .396-.23.752-.56.914-.98.498-1.87 1.138-2.66 1.88-.18.182-.43.284-.7.284-.28 0-.53-.112-.71-.295l-2.48-2.519c-.18-.173-.29-.427-.29-.711s.11-.538.29-.721C43.34 155.808 47.46 154 52 154c4.54 0 8.66 1.808 11.71 4.744.18.183.29.437.29.721s-.11.538-.29.721l-2.48 2.52c-.18.182-.43.294-.71.294-.27 0-.52-.112-.7-.284-.79-.752-1.69-1.382-2.67-1.88-.33-.162-.56-.508-.56-.914v-3.149c-1.44-.487-2.99-.741-4.59-.741z",
    transform: "translate(-40 -154)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationPhone);
export default __webpack_public_path__ + "static/media/conversation-phone.cda7e113d3884c3149964a9526ac1001.svg";
export { ForwardRef as ReactComponent };